<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div>{{ row.partner_role_name }}</div>
		<tooltip
			class="expire"
			v-if="!row.many_partner && row.is_expire == '1'"
			label="跟进已到期"
			content="达人已满足自动流转回团队公海，其余商务可认领达人"
		></tooltip>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import tooltip from '../../../components/tooltip';
export default {
	components: {
		tooltip,
	},
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.expire {
	font-size: 12px;
	color: #fa8f14;

	::v-deep .icon-a-help-circle-obangzhu-xian {
		font-size: 12px;
		color: #fa8f14;
	}
}
</style>
